import apiClient from './client';
import { AuthResponse, LoginRequest, User } from '../types';

export const authService = {
  // Generate OTP
  generateOtp: async (phone: string, verificationId?: string): Promise<void> => {
    await apiClient.post('/users/auth/otp/generate', {
      referenceId: phone,
      verificationId,
    });
  },

  // Verify OTP and Login
  verifyOtpAndLogin: async (loginRequest: LoginRequest): Promise<AuthResponse> => {
    const response = await apiClient.post<AuthResponse>('/users/auth/otp/verify', loginRequest);
    return response.data;
  },

  // Google OAuth Login
  googleLogin: async (authToken: string): Promise<AuthResponse> => {
    const response = await apiClient.post<AuthResponse>('/users/auth/google', { authToken });
    return response.data;
  },

  // Facebook OAuth Login
  facebookLogin: async (authToken: string): Promise<AuthResponse> => {
    const response = await apiClient.post<AuthResponse>('/users/auth/facebook', { authToken });
    return response.data;
  },

  // Temp Login (for development)
  tempLogin: async (email: string): Promise<AuthResponse> => {
    const response = await apiClient.post<AuthResponse>('/users/auth/login/temp', email, {
      headers: { 'Content-Type': 'text/plain' },
    });
    return response.data;
  },

  // Logout
  logout: async (): Promise<void> => {
    await apiClient.post('/users/auth/logout');
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
  },

  // Get user profile
  getProfile: async (): Promise<User> => {
    const response = await apiClient.get<User>('/users/profile');
    return response.data;
  },

  // Update profile
  updateProfile: async (user: Partial<User>): Promise<void> => {
    await apiClient.put('/users/profile', user);
  },
};
